import { render, staticRenderFns } from "./YourDashboardNoAssignments.vue?vue&type=template&id=6aa8fc90&scoped=true"
import script from "./YourDashboardNoAssignments.vue?vue&type=script&setup=true&lang=js"
export * from "./YourDashboardNoAssignments.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourDashboardNoAssignments.vue?vue&type=style&index=0&id=6aa8fc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8fc90",
  null
  
)

export default component.exports